import React from 'react';
import ReactDOM from 'react-dom';
import systemHelper from './helpers/system';
import NBAAllStarReconfigure from './components/NBAAllStarReconfigure.js';


/**
 * Renders the app in the #app-container div
 * @returns {undefined} undefined
 */
function init() {
  const shareData = {
    title: encodeURIComponent(document.title),
    summary: encodeURIComponent('Small ball vs. Big ball? Ringz vs. No Ringz? Mix things up with the NBA All-Star Lineup Generator'),
  };
  const iOSVersion = systemHelper.iOSVersion();
  const htmlEl = document.getElementsByTagName('html')[0];
  const supportsCssTransforms3d =
    htmlEl.className.indexOf('no-csstransforms3d') === -1;
  const touch =
    htmlEl.className.indexOf('no-touchevents') === -1;
  let isIOS = false;


  if (iOSVersion === 8 || iOSVersion === 9) {
    const originalClass = htmlEl.className;
    const newClass = originalClass + ' iOS-' + iOSVersion.toString();

    isIOS = true;

    htmlEl.className = newClass;
  }

  ReactDOM.render(
    React.createElement(NBAAllStarReconfigure, {
      shareData: shareData, 
      isIOS: isIOS, 
      supportsCssTransforms3d: supportsCssTransforms3d, 
      touch: touch}
    ),
    document.getElementById('app-container'));
}


// if the DOM is ready by the time this module is loaded,
// fire the init function, otherwise, listen for the window.onload event
if (document.readyState === 'complete') {
  init();
} else {
  window.onload = function () {
    init();
  };
}
